import { css } from '@emotion/core'
import styled from '@themes/theme'

const GmoneyStyle = css`
  margin-left: 2px;
  width: 15px;
`
const GuideWrapProps = props => css`
  .guide-box {
    margin: ${props.margin};
    padding: ${props.padding};
    font-size: ${props.fontSize}px;
    font-weight: ${props.fontWeight};
    color: ${props.color};
  }
`
export const GuideWrap = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  height: auto;
  padding: 8px 20px;
  background: ${props => props.theme.color.modalSubBg2};
  * {
    color: ${props => props.theme.color.modalSubTxt};
  }
  &.guide-notice {
    height: auto;
  }
  .point-txt {
    font-size: ${props => props.theme.font.title};
    position: relative;
    top: 1px;
  }
  .line {
    display: block;
    width: 100%;
    margin: 10px 0 12px;
    border-top: 1px solid ${props => props.theme.color.modalSubBg};
  }
  .guide-wrap-txt {
    flex:1;
    font-size: ${props => props.theme.font.large};

    svg {
      position: relative;
      top: 2px;
      width: 16px;
      margin-left: 2px;
    }
  }
  .guide-box {
    width: 100%;
    text-align: center;
    &.reward {
      height: 37px;
      color: ${props => props.theme.color.modalTxt};
      font-size: ${props => props.theme.font.large};
      background: ${props => props.theme.color.themeTxt};
      border-radius: 6px;
      line-height: 3.7rem;
      &.no-bg {
        background: none;
      }
      * {
        font-size: ${props => props.theme.font.large};
      }
    }
    &.goal {
      width: calc(50% - 4px);
      margin-bottom: 5px;
      background: ${props => props.theme.color.themeTxt};
      border-radius: 6px;
    }
    &.complete {
      padding: 20px;
      color: ${props => props.theme.color.modalTxt};
      font-size: ${props => props.theme.font.large};
      svg {
        top: 2px;
      }
    }
    &.reward-img {
      display: flex;
      justify-content: center;
      width: 100%;
      padding: 10px 0;
      align-items: center;
      img {
        width: 55px;
      }
    }
    &.small {
      margin: 16px 0;
      color: ${props => props.theme.color.btn};
      font-size: ${props => props.theme.font.medium};
    }
    &.thin, .thin {
      font-weight: ${props => props.theme.fontW.medium};
    }
    &--tit {
      display: block;
      padding: 3px;
      color: ${props => props.theme.color.modalTxt};
      border-bottom: 1px solid ${props => props.theme.color.modalBg};
    }
    &--txt {
      display: inline-block;
      padding: 5px 0 10px;
      color: ${props => props.theme.color.modalSubTxt};
      font-size: ${props => props.theme.font.small};
      .value {
        color: ${props => props.theme.color.modalTxt};
      }
    }
    svg {
      ${GmoneyStyle};
      top: 3px;
    }
  }

  .guide-tip {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    text-align: left;
    margin-top: 20px;
    padding: 0 2%;
    svg {
      width: 22px;
    }
    /* TipIco */
    & > svg {
      margin-right: 15px;
    }
    &--txt {
      font-size: ${props => props.theme.font.small};
      svg {
        position: relative;
        top: 2px;
        width: 12px;
      }
    }
  }
  ${GuideWrapProps};
`
const GuideImgWrapProps = props => css`
  .guide-txt {
    margin: ${props.margin};
    font-size: ${props.fontSize}px;
    font-weight: ${props.fontWeight}px;
    color: ${props.color};
  }
`
export const GuideImgWrap = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  padding-top: 18px;
  background: ${props => props.theme.color.themeTxt};
  border-radius: 16px 16px 0 0;
  .guide-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 94px;
    height: 94px;
    margin-top: -47px;
    margin-bottom: 10px;
    border-radius: 50%;
    background: ${props => props.theme.color.themeTxt};
  }
  .guide-character {
    width: 76px;
    height: auto;
    border-radius: 50%;
    background: #B7B7B750;
    &.success-character {
      width: 110px;
      background: ${props => props.theme.color.TP};
      border-radius: 0;
      transform: translate(17px, -8px);
    }
  }
  .guide-txt {
    color: ${props => props.theme.color.modalTxt};
    margin-bottom: 8px;
    &.big {
      margin: 0 0 22px;
      font-size: ${props => props.theme.font.large};
      * {
        font-size: ${props => props.theme.font.large};
      }
    }
  }
  ${GuideImgWrapProps};
`
